export default {"src":"https://images-cdn.curipod.com/d-3e0cfa59/_next/static/media/wake_county_wcpss.dd36f474.svg","height":67,"width":250};